import { render, staticRenderFns } from "./topic_badges.vue.js?vue&type=template&id=b77ddc80&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=template&id=b77ddc80&vue3"
import script from "./topic_badges.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=script&lang=js&vue3"
export * from "./topic_badges.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./topic_badges.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports